/**
 * fc-bundle-box.js
 * "Build Your Own Bundle" collection page — interaction logic.
 *
 * Reads product data from window.FC_BUNDLE_PRODUCTS and config from
 * window.FC_BUNDLE_CONFIG (both set by sections/fc-bundle-box.liquid).
 *
 * Checkout is native: clear the cart, add the 2 real variants via
 * /cart/add.js, then redirect to /checkout?discount=<code>, with a
 * cart-permalink fallback if /cart/add.js fails.
 *
 * Multiple bundle-box sections can exist on one page — everything is scoped
 * by the section's Shopify `section.id`, read from the root element's id.
 */
(function () {
  'use strict';

  /* ─── Built-in color name → hex map (fallback when no swatch/tag hex is set) ─── */
  var COLOR_NAME_MAP = {
    'black':      '#111111',
    'white':      '#FFFFFF',
    'navy':       '#1B2A4A',
    'navy blue':  '#1B2A4A',
    'grey':       '#9E9E9E',
    'gray':       '#9E9E9E',
    'light grey': '#D1D5DB',
    'light gray': '#D1D5DB',
    'charcoal':   '#36454F',
    'red':        '#DC2626',
    'blue':       '#2563EB',
    'light blue': '#93C5FD',
    'sky blue':   '#87CEEB',
    'royal blue': '#1E40AF',
    'green':      '#16A34A',
    'olive':      '#6B7028',
    'brown':      '#92400E',
    'tan':        '#D2B48C',
    'beige':      '#F5F0E8',
    'cream':      '#FFFDD0',
    'off white':  '#F8F5F0',
    'pink':       '#EC4899',
    'rose':       '#FB7185',
    'purple':     '#9333EA',
    'orange':     '#F97316',
    'yellow':     '#EAB308',
    'gold':       '#D4AF37',
    'silver':     '#C0C0C0',
    'maroon':     '#800000',
    'burgundy':   '#800020',
    'teal':       '#0D9488',
    'coral':      '#FF6B6B',
    'khaki':      '#C3B091',
    'camel':      '#C19A6B',
    'mint':       '#98FFB3',
    'lavender':   '#E6E6FA',
    'sand':       '#C2B280',
    'stone':      '#A8A09A',
    'slate':      '#64748B',
    'cobalt':     '#0047AB',
    'emerald':    '#50C878',
  };

  /* ─── Config ─────────────────────────────────────────── */
  var CFG              = window.FC_BUNDLE_CONFIG || {};
  var PRODUCTS         = window.FC_BUNDLE_PRODUCTS || [];
  var DISCOUNT         = CFG.discountCode || '';
  // Already formatted server-side with Liquid's money filter, so it carries
  // the shop's own currency symbol and separators — no client-side formatting.
  var BUNDLE_PRICE     = CFG.bundlePriceMoney || '';

  /* ─── State ──────────────────────────────────────────── */
  var box         = [null, null];   // 2 slots
  var pending     = null;           // product being configured
  var replaceSlot = null;           // slot index to replace (0 or 1)
  var selColor    = null;
  var selSize     = null;
  var hasColors   = false;
  var sectionId   = null;

  /* ─── localStorage persistence ──────────────────────── */
  var STORAGE_KEY = 'fc_bundle_box';

  function saveBox() {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(box)); } catch (e) {}
  }

  function loadBox() {
    try {
      var saved = localStorage.getItem(STORAGE_KEY);
      if (!saved) return;
      var parsed = JSON.parse(saved);
      if (Array.isArray(parsed) && parsed.length === 2) {
        box = parsed;
      }
    } catch (e) {
      try { localStorage.removeItem(STORAGE_KEY); } catch (e2) {}
    }
  }

  function clearSavedBox() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  /* ─── DOM id helper — every element is scoped by section.id ──────────── */
  function id(base) {
    return document.getElementById(base + '-' + sectionId);
  }

  /* ─── Build a variant lookup map for a product ───────── */
  function buildVariantMap(product) {
    var map = {};
    var opts = product.options || [];
    var colorIdx = -1;
    var sizeIdx  = -1;

    opts.forEach(function (name, i) {
      var n = name.toLowerCase().trim();
      if (n === 'color' || n === 'colour' || n.indexOf('color') !== -1 || n.indexOf('colour') !== -1) colorIdx = i;
      if (n === 'shoe size' || n === 'size' || n.indexOf('size') !== -1) sizeIdx = i;
    });

    product.variants.forEach(function (v) {
      var o = [v.option1, v.option2, v.option3];
      if (colorIdx !== -1 && sizeIdx !== -1) {
        var c = o[colorIdx] || '';
        var s = o[sizeIdx]  || '';
        if (!map[c]) map[c] = {};
        map[c][s] = { id: v.id, available: v.available, image: v.image };
      } else if (sizeIdx !== -1) {
        var s2 = o[sizeIdx] || '';
        map[s2] = { id: v.id, available: v.available, image: v.image };
      } else {
        var k = o[0] || 'Default';
        map[k] = { id: v.id, available: v.available, image: v.image };
      }
    });
    return map;
  }

  /* ─── Tab filtering ─────────────────────────────────── */
  function filterTab(cat, btn, tabsRoot) {
    tabsRoot.querySelectorAll('.fc-bundle-tab-btn').forEach(function (b) {
      b.classList.remove('active');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('active');
    btn.setAttribute('aria-pressed', 'true');

    id('fcb-product-grid').querySelectorAll('.fc-bundle-card').forEach(function (card) {
      var tags = (card.dataset.tags || '').split(',').map(function (t) { return t.trim(); });
      var show = (cat === 'all') || tags.indexOf(cat) !== -1;
      card.classList.toggle('fc-bc-hidden', !show);
    });

    renderCards();
  }

  /* ─── Open picker ────────────────────────────────────── */
  function openPicker(btn) {
    var card = btn.closest('.fc-bundle-card');
    if (!card) return;
    var pid     = Number(card.dataset.pid);
    var product = PRODUCTS.find(function (p) { return p.id === pid; });
    if (!product) return;

    // Read color hex map from the card's rendered color dots — avoids any JSON/HTML quoting issues
    var colorHexMap = {};
    card.querySelectorAll('.fc-bundle-color-dot-sm').forEach(function (dot) {
      var name = dot.getAttribute('title');
      var bg   = dot.style.background || dot.style.backgroundColor;
      if (name && bg) colorHexMap[name] = bg;
    });

    pending = {
      pid:         pid,
      product:     product,
      card:        card,
      varMap:      buildVariantMap(product),
      colorHexMap: colorHexMap,
    };
    selColor = null;
    selSize  = null;

    if (box[0] && box[1]) {
      showReplace();
    } else {
      showPicker();
    }
  }

  /* ─── Picker modal ───────────────────────────────────── */
  function showPicker() {
    var p     = pending.product;
    var imgEl = id('fcb-modal-img');

    var nameEl = id('fcb-modal-name');
    if (nameEl) nameEl.textContent = p.title;

    if (imgEl && p.image) {
      imgEl.innerHTML = '<img src="' + p.image + '" alt="' + escapeHtml(p.title) + '" width="68" height="68" loading="lazy">';
    } else if (imgEl) {
      imgEl.innerHTML = '';
    }

    var opts     = p.options || [];
    var colorIdx = -1;
    var sizeIdx  = -1;
    opts.forEach(function (name, i) {
      var n = name.toLowerCase().trim();
      if (n === 'color' || n === 'colour' || n.indexOf('color') !== -1 || n.indexOf('colour') !== -1) colorIdx = i;
      if (n === 'shoe size' || n === 'size' || n.indexOf('size') !== -1) sizeIdx = i;
    });

    hasColors = colorIdx !== -1;

    var colorToImage = {};
    p.variants.forEach(function (v) {
      if (!v.image) return;
      var cv = (colorIdx === 0 ? v.option1 : colorIdx === 1 ? v.option2 : v.option3) || '';
      if (cv && !colorToImage[cv]) colorToImage[cv] = v.image;
    });
    pending.colorToImage = colorToImage;

    var colorSec = id('fcb-color-section');
    var cGrid    = id('fcb-color-grid');
    var cLabel   = id('fcb-selected-color-name');

    if (hasColors) {
      colorSec.style.display = '';
      cLabel.textContent     = 'select one';
      cGrid.innerHTML        = '';
      var seenColors         = {};

      p.variants.forEach(function (v) {
        var colorVal = (colorIdx === 0 ? v.option1 : colorIdx === 1 ? v.option2 : v.option3) || '';
        if (!colorVal || seenColors[colorVal]) return;
        var hasStock = p.variants.some(function (vv) {
          var cv = (colorIdx === 0 ? vv.option1 : colorIdx === 1 ? vv.option2 : vv.option3) || '';
          return cv === colorVal && vv.available;
        });
        if (!hasStock) return;
        seenColors[colorVal] = true;

        var sw = document.createElement('button');
        sw.type      = 'button';
        sw.className = 'fc-bundle-color-swatch';
        sw.title     = colorVal;
        sw.setAttribute('aria-label', colorVal);
        sw.dataset.colorVal = colorVal;

        var colorKey = colorVal.toLowerCase();
        var hex = (pending.colorHexMap && pending.colorHexMap[colorVal])
          || COLOR_NAME_MAP[colorKey]
          || (colorKey.indexOf(' ') === -1 ? colorKey : null)
          || '#cccccc';
        sw.style.background = hex;

        sw.addEventListener('click', function () {
          cGrid.querySelectorAll('.fc-bundle-color-swatch').forEach(function (s) {
            s.classList.remove('selected');
          });
          sw.classList.add('selected');
          selColor = colorVal;
          cLabel.textContent = colorVal;
          var varImg = pending.colorToImage && pending.colorToImage[colorVal];
          if (varImg && imgEl) {
            imgEl.innerHTML = '<img src="' + varImg + '" alt="' + escapeHtml(colorVal) + '" width="68" height="68" loading="lazy">';
          }
          renderSizeGrid(colorVal);
          updateConfirmBtn();
        });
        cGrid.appendChild(sw);
      });
    } else {
      colorSec.style.display = 'none';
      selColor = 'Default';
    }

    renderSizeGrid(null);
    var sName = id('fcb-selected-size-name');
    if (sName) sName.textContent = 'pick a color first';

    updateConfirmBtn();
    var dialogEl = document.getElementById('fcb-picker-dialog-' + sectionId);
    if (dialogEl && typeof dialogEl.showDialog === 'function') dialogEl.showDialog();
  }

  function renderSizeGrid(selectedColor) {
    var p      = pending.product;
    var varMap = pending.varMap;
    var sGrid  = id('fcb-size-grid');
    var sLabel = id('fcb-selected-size-name');
    if (!sGrid) return;
    sGrid.innerHTML = '';
    selSize = null;
    if (sLabel) sLabel.textContent = 'select one';

    var sizes   = [];
    var opts    = p.options || [];
    var sizeIdx = -1;
    opts.forEach(function (name, i) {
      var n = name.toLowerCase().trim();
      if (n === 'shoe size' || n === 'size' || n.indexOf('size') !== -1) sizeIdx = i;
    });

    if (sizeIdx === -1) {
      var btn = document.createElement('button');
      btn.type        = 'button';
      btn.className   = 'fc-bundle-size-btn';
      btn.textContent = 'One Size';
      btn.addEventListener('click', function () {
        sGrid.querySelectorAll('.fc-bundle-size-btn').forEach(function (b) { b.classList.remove('selected'); });
        btn.classList.add('selected');
        selSize = 'One Size';
        if (sLabel) sLabel.textContent = 'One Size';
        updateConfirmBtn();
      });
      sGrid.appendChild(btn);
      return;
    }

    var seen = {};
    p.variants.forEach(function (v) {
      var sVal = (sizeIdx === 0 ? v.option1 : sizeIdx === 1 ? v.option2 : v.option3) || '';
      if (sVal && !seen[sVal]) { seen[sVal] = true; sizes.push(sVal); }
    });

    sizes.forEach(function (sVal) {
      var available = true;
      if (hasColors && selectedColor && varMap[selectedColor]) {
        var entry = varMap[selectedColor][sVal];
        available = entry ? entry.available : false;
      } else if (!hasColors) {
        var entry2 = varMap[sVal];
        available = entry2 ? entry2.available : false;
      }

      if (!available) return;

      var btn = document.createElement('button');
      btn.type        = 'button';
      btn.className   = 'fc-bundle-size-btn';
      btn.textContent = sVal;

      btn.addEventListener('click', function () {
        sGrid.querySelectorAll('.fc-bundle-size-btn').forEach(function (b) { b.classList.remove('selected'); });
        btn.classList.add('selected');
        selSize = sVal;
        if (sLabel) sLabel.textContent = sVal;
        updateConfirmBtn();
      });
      sGrid.appendChild(btn);
    });
  }

  function updateConfirmBtn() {
    var btn = id('fcb-confirm-btn');
    if (!btn) return;
    var ready = selSize && (!hasColors || selColor);
    btn.disabled = !ready;

    if (ready) {
      var label = 'Add to Box';
      if (selColor && hasColors) label += ' — ' + selColor;
      if (selSize)                label += ' / ' + selSize;
      label += ' →';
      btn.textContent = label;
    } else if (!selSize && (!hasColors || selColor)) {
      btn.textContent = 'Select a size to continue';
    } else {
      btn.textContent = 'Select color & size to continue';
    }
  }

  function closePicker() {
    var dialogEl = document.getElementById('fcb-picker-dialog-' + sectionId);
    if (dialogEl && typeof dialogEl.closeDialog === 'function') dialogEl.closeDialog();
    pending     = null;
    selColor    = null;
    selSize     = null;
    replaceSlot = null;
  }

  /* ─── Confirm add to box ─────────────────────────────── */
  function confirmAdd() {
    if (!pending || !selSize) return;

    var slot = replaceSlot !== null
      ? replaceSlot
      : box.findIndex(function (s) { return s === null; });

    if (slot === -1) return;

    var varMap = pending.varMap;
    var variantEntry;
    if (hasColors && selColor && selColor !== 'Default') {
      variantEntry = varMap[selColor] && varMap[selColor][selSize];
    } else {
      variantEntry = varMap[selSize] || varMap['Default'];
    }
    if (!variantEntry) {
      console.warn('[FC Bundle] Variant not found for', selColor, selSize);
      return;
    }

    var variantImage = (pending.colorToImage && selColor && pending.colorToImage[selColor])
      || variantEntry.image
      || pending.product.image;

    box[slot] = {
      pid:       pending.product.id,
      title:     pending.product.title,
      image:     variantImage,
      variantId: variantEntry.id,
      color:     (hasColors && selColor !== 'Default') ? selColor : null,
      size:      selSize,
    };

    replaceSlot = null;
    saveBox();
    closePicker();
    closeReplace();
    renderOverlay();
    renderCards();
  }

  /* ─── Replace modal ──────────────────────────────────── */
  function showReplace() {
    [0, 1].forEach(function (i) {
      var item  = box[i];
      var imgEl = id('fcb-replace-img-' + i);
      if (imgEl && item.image) {
        imgEl.innerHTML = '<img src="' + item.image + '" alt="" width="52" height="52" loading="lazy">';
      }
      var nameEl = id('fcb-replace-name-' + i);
      if (nameEl) nameEl.textContent = item.title;
      var det = item.size;
      if (item.color) det = item.color + ' / ' + det;
      var detailEl = id('fcb-replace-detail-' + i);
      if (detailEl) detailEl.textContent = det;

      var replaceBtn = document.querySelector(
        '#fcb-replace-dialog-' + sectionId + ' [data-fcb-replace="' + i + '"]'
      );
      if (replaceBtn) {
        replaceBtn.setAttribute('aria-label', 'Replace Pair ' + (i + 1) + ': ' + item.title + ', ' + det);
      }
    });
    var dialogEl = document.getElementById('fcb-replace-dialog-' + sectionId);
    if (dialogEl && typeof dialogEl.showDialog === 'function') dialogEl.showDialog();
  }

  function doReplace(slotIdx) {
    replaceSlot = slotIdx;
    closeReplace();
    showPicker();
  }

  function closeReplace() {
    var dialogEl = document.getElementById('fcb-replace-dialog-' + sectionId);
    if (dialogEl && typeof dialogEl.closeDialog === 'function') dialogEl.closeDialog();
  }

  /* ─── Remove from slot ───────────────────────────────── */
  function removeSlot(i) {
    if (!box[i]) return;
    box[i] = null;
    saveBox();
    renderOverlay();
    renderCards();
  }

  /* ─── Render overlay ─────────────────────────────────── */
  function renderOverlay() {
    var filled = box.filter(Boolean).length;

    var pf = id('fcb-progress-fill');
    if (pf) pf.style.width = (filled / 2 * 100) + '%';

    var countEl = id('fcb-selected-count');
    if (countEl) countEl.textContent = filled + ' of 2 pairs selected';

    [0, 1].forEach(function (i) {
      var slotEl = id('fcb-slot-' + i);
      if (!slotEl) return;
      var item = box[i];

      if (item) {
        slotEl.classList.add('filled');
        var det = item.size;
        if (item.color) det = item.color + ' / ' + det;
        var imgHtml = item.image
          ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" width="44" height="44" loading="lazy">'
          : '';

        slotEl.innerHTML =
          '<div class="fc-bundle-slot-label">Pair ' + (i + 1) + '</div>' +
          '<div class="fc-bundle-slot-img">' + imgHtml + '</div>' +
          '<div class="fc-bundle-slot-info">' +
            '<div class="fc-bundle-slot-name">' + escapeHtml(item.title) + '</div>' +
            '<div class="fc-bundle-slot-detail">' + escapeHtml(det) + '</div>' +
          '</div>' +
          '<button type="button" class="fc-bundle-slot-remove" data-fcb-remove="' + i + '" aria-label="Remove pair ' + (i + 1) + '">&#x2715;</button>';
      } else {
        slotEl.classList.remove('filled');
        slotEl.innerHTML =
          '<div class="fc-bundle-slot-label">Pair ' + (i + 1) + '</div>' +
          '<div class="fc-bundle-slot-empty">+ Add ' + (i === 0 ? 'first' : 'second') + ' pair</div>';
      }
    });

    var priceVal = id('fcb-bundle-price-val');
    if (priceVal) priceVal.textContent = BUNDLE_PRICE;

    var btn = id('fcb-checkout-btn');
    var txt = id('fcb-checkout-btn-text');
    if (!btn) return;

    if (filled === 2) {
      btn.disabled    = false;
      txt.textContent = 'Checkout — ' + BUNDLE_PRICE;
    } else if (filled === 1) {
      btn.disabled    = true;
      txt.textContent = 'Pick 1 More Pair';
    } else {
      btn.disabled    = true;
      txt.textContent = 'Select 2 Pairs';
    }
  }

  /* ─── Dim non-selected cards when box is full ────────── */
  function renderCards() {
    var full = box[0] && box[1];
    var boxPids = box.filter(Boolean).map(function (item) { return item.pid; });
    id('fcb-product-grid').querySelectorAll('.fc-bundle-card').forEach(function (c) {
      c.classList.toggle('fc-bc-in-box', boxPids.indexOf(Number(c.dataset.pid)) !== -1);
      if (c.classList.contains('fc-bc-hidden')) return;
      c.classList.toggle('fc-bc-dimmed', !!full);
    });
  }

  /* ─── Checkout ───────────────────────────────────────── */
  function checkout() {
    var btn = id('fcb-checkout-btn');
    var txt = id('fcb-checkout-btn-text');
    if (btn) btn.disabled = true;
    if (txt) txt.innerHTML = '<span class="fc-bundle-spinner"></span>Loading checkout…';

    var v1 = box[0] && box[0].variantId;
    var v2 = box[1] && box[1].variantId;
    if (!v1 || !v2) {
      if (btn) btn.disabled = false;
      if (txt) txt.textContent = 'Checkout — ' + BUNDLE_PRICE;
      return;
    }

    var shopifyRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var base        = shopifyRoot === '/' ? '' : shopifyRoot.replace(/\/+$/, '');

    checkoutNative(v1, v2, base);
  }

  function findProduct(pid) {
    return PRODUCTS.find(function (p) { return p.id === pid; });
  }

  /* Clears the real cart, adds only the 2 bundle variants, then redirects to
     Shopify checkout with the discount code as a query param. Falls back to a
     cart permalink if /cart/add.js fails (e.g. rate-limited). */
  function checkoutNative(v1, v2, base) {
    var discountQs = DISCOUNT ? '?discount=' + encodeURIComponent(DISCOUNT) : '';

    function goNativeCheckout() {
      window.location.href = base + '/checkout' + discountQs;
    }

    function goPermalinkCheckout() {
      window.location.href = base + '/cart/' + v1 + ':1,' + v2 + ':1' + discountQs;
    }

    fetch('/cart/clear.js', { method: 'POST' })
      .catch(function () {})
      .then(function () {
        return fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({
            items: [
              { id: v1, quantity: 1 },
              { id: v2, quantity: 1 },
            ],
          }),
        });
      })
      .then(function (r) {
        clearSavedBox();
        if (r.ok) {
          goNativeCheckout();
        } else {
          goPermalinkCheckout();
        }
      })
      .catch(function () {
        clearSavedBox();
        goPermalinkCheckout();
      });
  }

  /* ─── Helpers ────────────────────────────────────────── */
  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ─── Init ───────────────────────────────────────────── */
  function init(root) {
    sectionId = root.id.replace('fc-bundle-box-', '');

    var tabsWrap = root.querySelector('.fc-bundle-tabs');
    if (tabsWrap) {
      tabsWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('.fc-bundle-tab-btn');
        if (!btn) return;
        filterTab(btn.dataset.fcbTab, btn, tabsWrap);
      });
    }

    root.addEventListener('click', function (e) {
      var addBtn = e.target.closest('.fc-bundle-add-btn');
      if (addBtn && !addBtn.disabled) openPicker(addBtn);
    });

    var overlay = document.getElementById('fc-bundle-overlay-' + sectionId);
    if (overlay) {
      overlay.addEventListener('click', function (e) {
        var removeBtn = e.target.closest('[data-fcb-remove]');
        if (removeBtn) { removeSlot(Number(removeBtn.dataset.fcbRemove)); return; }
        var checkoutBtn = e.target.closest('#fcb-checkout-btn-' + sectionId);
        if (checkoutBtn && !checkoutBtn.disabled) checkout();
      });
    }

    var pickerDialog = document.getElementById('fcb-picker-dialog-' + sectionId);
    if (pickerDialog) {
      pickerDialog.addEventListener('click', function (e) {
        if (e.target.closest('#fcb-confirm-btn-' + sectionId)) confirmAdd();
      });
      pickerDialog.addEventListener('dialog:close', function () {
        pending = null; selColor = null; selSize = null; replaceSlot = null;
      });
    }

    var replaceDialog = document.getElementById('fcb-replace-dialog-' + sectionId);
    if (replaceDialog) {
      replaceDialog.addEventListener('click', function (e) {
        var replaceBtn = e.target.closest('[data-fcb-replace]');
        if (replaceBtn) doReplace(Number(replaceBtn.dataset.fcbReplace));
      });
    }

    loadBox();
    renderOverlay();
    renderCards();
  }

  function boot() {
    document.querySelectorAll('.fc-bundle-page').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
